import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContentCard = styled(Card)`
  margin-top: 32px;
`;
